import { useTranslation, useGenerateReport } from 'hooks';
import Button from 'shared/ui/button/button';
import { Loader } from 'shared/ui/loader/loader';
import { DashboardStateCard } from '../../components/dashboard-state-card/dashboard-state-card';

export const ReportError: React.FC = () => {
  const { t } = useTranslation();
  const { isGenerating, handleRegenerate } = useGenerateReport();

  return (
    <DashboardStateCard
      title={t('reportGenFailed')}
      description={t('reportGenFailedText')}
    >
      <Button
        theme='filled'
        tone='default'
        disabled={isGenerating}
        onClick={isGenerating ? undefined : () => handleRegenerate(true)}
      >
        {isGenerating ? <Loader size={20} /> : t('regenerateReport')}
      </Button>
      <Button theme='text' tone='default'>
        {t('contactSupport')}
      </Button>
    </DashboardStateCard>
  );
};
